export enum WalletConnectStatus {
  connecting = "Connecting",
  disconnected = "Disconnected",
  idle = "Idle",
  connected = "Connected",
}
